import { REDLINE_RANGE_END, REDLINE_RANGE_START } from '../../../llm-range-markers';

/**
 * These constants are unicode characters that are reserved for private use in
 * the unicode specification so should not appear in any text.
 */

export const RANGE_START = REDLINE_RANGE_START;
export const RANGE_END = REDLINE_RANGE_END;
export const DELETE_PLACEHOLDER = '\uE002';
